import React from 'react';
import { motion } from 'framer-motion';
/**
 * A barber clipper that streaks across the screen like a shooting star,
 * leaving a soft blurred light trail behind it. Purely decorative.
 */
export function ShootingClipper() {
  return <div className="fixed inset-0 z-[5] pointer-events-none overflow-hidden" data-id="element-196">
      <motion.div
    // Travels diagonally from the top-left off-screen to the bottom-right off-screen
    initial={{
      x: '-20vw',
      y: '-25vh',
      opacity: 0
    }} animate={{
      x: ['-20vw', '120vw'],
      y: ['-25vh', '125vh'],
      opacity: [0, 1, 1, 0]
    }} transition={{
      duration: 3.2,
      ease: 'easeIn',
      times: [0, 0.1, 0.85, 1],
      repeat: Infinity,
      repeatDelay: 6
    }} className="absolute top-0 left-0 flex items-center" style={{
      rotate: '45deg'
    }} data-id="element-197">
        {/* Blurred light trail (the "shooting star" tail) */}
        <div className="h-[3px] w-56 md:w-80 rounded-full blur-[3px]" style={{
        background: 'linear-gradient(90deg, rgba(220,38,38,0) 0%, rgba(239,68,68,0.35) 55%, rgba(255,255,255,0.9) 100%)'
      }} data-id="element-198" />
        {/* Glow halo around the clipper head */}
        <div className="absolute right-0 w-16 h-16 -mr-6 rounded-full bg-red-500/40 blur-2xl" data-id="element-199" />

        {/* The clipper itself */}
        <div className="relative -ml-2" style={{
        rotate: '-45deg'
      }} data-id="element-200">
          <ClipperIcon data-id="element-201" />
        </div>
      </motion.div>
    </div>;
}
function ClipperIcon() {
  return <svg width="34" height="34" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="drop-shadow-[0_0_8px_rgba(239,68,68,0.7)]" data-id="element-202">
      {/* Body */}
      <rect x="14" y="12" width="20" height="26" rx="4" fill="#e4e4e7" data-id="element-203" />
      <rect x="14" y="12" width="20" height="8" rx="4" fill="#a1a1aa" data-id="element-204" />
      {/* Center detail line */}
      <rect x="18" y="22" width="12" height="3" rx="1.5" fill="#dc2626" data-id="element-205" />
      <rect x="18" y="28" width="12" height="2" rx="1" fill="#71717a" data-id="element-206" />
      {/* Blade teeth at the top */}
      <g fill="#f4f4f5" data-id="element-207">
        <rect x="15" y="6" width="2.5" height="6" rx="1" data-id="element-208" />
        <rect x="19" y="6" width="2.5" height="6" rx="1" data-id="element-209" />
        <rect x="23" y="6" width="2.5" height="6" rx="1" data-id="element-210" />
        <rect x="27" y="6" width="2.5" height="6" rx="1" data-id="element-211" />
        <rect x="31" y="6" width="2.5" height="6" rx="1" data-id="element-212" />
      </g>
      {/* Cord */}
      <path d="M24 38 C24 43, 30 43, 30 46" stroke="#52525b" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-213" />
    </svg>;
}